import React, { PureComponent } from 'react';
import { node } from 'prop-types';
import { withWishlistData } from 'connectors';
import { wishlistShape } from 'shapes';
import { Provider } from './WishListContext';

class WishListProvider extends PureComponent {
    static propTypes = {
        children: node,
        wishlist: wishlistShape.isRequired,
    };

    static defaultProps = {
        children: null,
    };

    constructor(props) {
        super(props);
        const productIds =
            (props.wishlist.cacheManager &&
                props.wishlist.cacheManager.productIds) ||
            null;
        this.state = {
            productIds,
        };
    }

    componentDidMount() {
        const { wishlist } = this.props;
        if (wishlist && wishlist.cacheManager) {
            wishlist.cacheManager.addAvailableListener(this.setProductIds);
            wishlist.cacheManager.addListenerAdd(this.setProductIds);
            wishlist.cacheManager.addListenerRemove(this.setProductIds);
        }
    }

    componentWillUnmount() {
        const { wishlist } = this.props;
        if (wishlist && wishlist.cacheManager) {
            wishlist.cacheManager.removeAvailableListener(this.setProductIds);
            wishlist.cacheManager.removeListenerAdd(this.setProductIds);
            wishlist.cacheManager.removeListenerRemove(this.setProductIds);
        }
    }

    setProductIds = () => {
        this.setState({
            productIds: this.props.wishlist.cacheManager.productIds,
        });
    };

    render() {
        const { children, wishlist } = this.props;
        return (
            <Provider
                value={{
                    actions: {
                        openWishlistModal: wishlist.openModal,
                    },
                    state: {
                        areProductIdsLoaded: !!this.state.productIds,
                        productIds: this.state.productIds,
                    },
                }}
            >
                {children}
            </Provider>
        );
    }
}

export default withWishlistData(WishListProvider);
